import { useState, useEffect, CSSProperties, RefObject } from "react";

export const useButtonEffect = (
  buttonRef: RefObject<HTMLAnchorElement | HTMLButtonElement>
): CSSProperties => {
  const [effectStyles, setEffectStyles] = useState({
    x: 0,
    y: 0,
    size: 0,
    opacity: 0,
  });

  useEffect(() => {
    const currentButtonRef = buttonRef.current;

    const onButtonMouseDown = (event: any) => {
      const currentButton = event.currentTarget as HTMLElement;

      const x = event.clientX - currentButton.getBoundingClientRect().left;
      const y = event.clientY - currentButton.getBoundingClientRect().top;

      setEffectStyles({ x, y, size: 50, opacity: 1 });

      setTimeout(() => {
        setEffectStyles({ x, y, size: 500, opacity: 1 });
      }, 250);

      setTimeout(() => {
        setEffectStyles({ x, y, size: 0, opacity: 0 });
      }, 500);
    };

    if (buttonRef && currentButtonRef) {
      currentButtonRef.addEventListener("mousedown", onButtonMouseDown);
    }

    return () => {
      if (buttonRef && currentButtonRef) {
        currentButtonRef.removeEventListener("mousedown", onButtonMouseDown);
      }
    };
  }, [buttonRef]);

  const style = {
    "--x": `${effectStyles.x}px`,
    "--y": `${effectStyles.y}px`,
    "--size": `${effectStyles.size}px`,
    "--opacity": effectStyles.opacity,
  } as CSSProperties;

  return style;
};
